module.exports = __webpack_public_path__ + "static/media/uniregistry.5828339c.svg";